/**
 * @desc 最后一个节点审批
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(
  body: defs.fulfilment.WarehouseCostApprovalPassReceptionDto,
  options?: any,
) {
  return updateResponse(
    http(URL + `/warehouseCost/pass`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
